import { Directive } from '@angular/core';

@Directive({
  selector: '[sidePanelContent], side-panel-content',
  host: {
    class: 'w-full flex-1 flex flex-col',
  },
})
export class SidePanelContentDirective {}
